import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { cancelImpersonation, startSession } from 'app/modules/session/actions';
import {
  clearRoutingHistory,
  getImpersonateLogId,
  setImpersonateId,
  setImpersonateLogId,
} from 'app/shared/utils/sessionStorage';
import routes from 'app/shared/utils/routes';
import { history } from 'app/store/browserHistory';
import { queryClient } from 'app/cache/queryClient';
import { put, setPreSwitchTimestamp } from 'app/shared/utils/fetchr';
import { AuthClient } from 'app/modules/session/models';
import { sendErrorToast } from 'app/shared/toasts/actions';
import { CancelImpersonationPayload } from 'app/modules/impersonation/requests';

export const useCancelImpersonation = (authClient: AuthClient) => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: async () => {
      const impersonateLogID = getImpersonateLogId();
      return put('/agents/log-impersonation-cancelled', {
        impersonation_log_id: impersonateLogID,
      } satisfies CancelImpersonationPayload);
    },
    onSuccess: async () => {
      await queryClient.cancelQueries();
      setPreSwitchTimestamp();
      // Clear impersonation session data
      setImpersonateId(-1);
      setImpersonateLogId(-1);

      // Reset app state
      clearRoutingHistory();
      dispatch({ type: '@@rootReducer/RESET_APP' });
      dispatch(startSession(authClient));

      dispatch(cancelImpersonation());
      history.push(routes.lumos.home);
      queryClient.clear();
    },
    onError: () => {
      dispatch(
        sendErrorToast('Failed to cancel impersonation. Please try again.'),
      );
    },
  });
};
